import "./DiscountType.css";

// 1. Import KeyboardEvent
import { useEffect, useRef, KeyboardEvent } from "react";

import Radio from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";

import { DiscountDetails } from "./ViewOrderType";

const DiscountType: React.FC<{
  type: string;
  handleRadioToggle: () => void;
  discount: DiscountDetails;
  labelSuffix?: string;
  handleDiscountValueChange: (value: string) => void;
  maxVal: number;
}> = ({
  type,
  handleRadioToggle,
  discount,
  labelSuffix = "",
  handleDiscountValueChange,
  maxVal,
}) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const { discountType, discountValue } = discount;

  const isDiscountTypeSelected = discountType === type?.toLocaleUpperCase();

  useEffect(() => {
    if (isDiscountTypeSelected && inputRef.current) {
      setTimeout(() => {
        inputRef.current?.focus();
      }, 0);
    }
  }, [isDiscountTypeSelected]);
  
  // 2. Add a key down handler
  const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    // Check if the pressed key is 'Enter' or ' ' (Space)
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault(); // Prevent default action (like scrolling)
      handleRadioToggle(); // Trigger the same action as a click
    }
  };

  return (
    <div
      className="discount-type-container"
      onClick={handleRadioToggle}
      onKeyDown={handleKeyDown} // 3. Attach the key down handler
      tabIndex={0} // 4. Make the div focusable
      style={
        isDiscountTypeSelected
          ? { borderColor: "#227C9D", background: "#F0FBFF" }
          : { borderColor: "#EBEBEB", background: "#fff" }
      }
    >
      <div className="discountType-selection">
        <FormControlLabel
          value={type?.toUpperCase()}
          control={<Radio sx={{ "& .MuiSvgIcon-root": { fontSize: 18 } }} />}
          label={`${type} ${labelSuffix}`}
          checked={isDiscountTypeSelected}
          // The click event on the parent div handles the logic, so we make this non-interactive for simplicity.
          sx={{
            "& .MuiFormControlLabel-label": {
              color: "#5A5A5A",
              fontSize: "13px",
              fontWeight: 500,
            },
            pointerEvents: "none",
          }}
        />
      </div>
      {isDiscountTypeSelected ? (
        <div className="discountType-values">
          <input
            ref={inputRef}
            value={discountValue}
            onChange={(e) => {
              const value = e.target.value;
              if (/^\d*\.?\d{0,2}$/.test(value)) {
                const numericValue = parseFloat(value);
                if (value === "" || (!isNaN(numericValue) && numericValue <= maxVal)) {
                  handleDiscountValueChange(value);
                }
              }
            }}
          />
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

export default DiscountType;